module.exports = __webpack_public_path__ + "img/upload.3d8539a3.svg";